"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("@fluentui/react");
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var Action_1 = require("../../Services/Redux/Action");
require("./ErrorPage.scss");
var mapDispatchToProps = {
    notifyError: Action_1.notifyErrorAction
};
var connector = react_redux_1.connect(undefined, mapDispatchToProps);
var ErrorPage = function (props) {
    var notifyError = props.notifyError, match = props.match, customId = props.customId;
    var errorId = customId || (match.params.id || 404);
    var history = react_router_dom_1.useHistory();
    var location = react_router_dom_1.useLocation();
    var t = react_i18next_1.useTranslation('httpError').t;
    return (react_1.default.createElement("div", { className: 'panel eta-error-layout' },
        react_1.default.createElement("div", { className: 'eta-error' },
            react_1.default.createElement("img", { src: "/assets/img/Error.svg", alt: "Error" }),
            react_1.default.createElement("div", { className: 'eta-error-Details' },
                react_1.default.createElement("h2", null, t("httpError" + (errorId !== null && errorId !== void 0 ? errorId : '') + ".title")),
                react_1.default.createElement("span", null, t("httpError" + (errorId !== null && errorId !== void 0 ? errorId : '') + ".description")),
                react_1.default.createElement("div", { className: 'eta-error-DetailsAction' },
                    react_1.default.createElement(react_2.PrimaryButton, { iconProps: { iconName: 'Home' }, text: t('httpError.backHome'), onClick: function () {
                            history.push('/home');
                        } }),
                    react_1.default.createElement(react_2.ActionButton, { text: t('httpError.NotExpectErrorReport'), onClick: function () {
                            notifyError({
                                event: "Navigation Error " + errorId,
                                error: {
                                    name: "Navigation Error " + errorId,
                                    message: "path: " + location.pathname + " - return " + errorId
                                }
                            }, true);
                        } }))))));
};
exports.default = connector(ErrorPage);
//# sourceMappingURL=ErrorPage.js.map